import { render, staticRenderFns } from "./TopicDetails.vue?vue&type=template&id=5b4c03ad&scoped=true&"
import script from "./TopicDetails.vue?vue&type=script&lang=js&"
export * from "./TopicDetails.vue?vue&type=script&lang=js&"
import style0 from "./TopicDetails.vue?vue&type=style&index=0&id=5b4c03ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c03ad",
  null
  
)

export default component.exports